import React from 'react';
import { useLanguage } from '../i18n/LanguageContext';
import { trackEvent } from '../lib/customerEventTracker';

const WhatsAppButton = () => {
  const { t } = useLanguage();
  return (
    <a
      href="https://wa.me/919346004430?text=Hello%20Can%20I%20get%20More%20Information"
      target="_blank"
      rel="noopener noreferrer"
      className="fixed right-5 bottom-24 lg:bottom-6 lg:right-6 z-40"
      aria-label={t('wa.aria', 'Chat on WhatsApp')}
      onClick={() =>
        trackEvent({
          event_name: 'cta_click',
          event_action: 'click',
          event_status: 'success',
          event_category: 'support',
          cta_name: 'whatsapp_fab',
        })
      }
    >
      <div className="relative pulse-ring">
        <div className="w-14 h-14 rounded-full bg-[#25D366] hover:bg-[#1da851] flex items-center justify-center shadow-lg shadow-[#25D366]/40 transition-colors">
          <svg viewBox="0 0 32 32" className="w-7 h-7 fill-white">
            <path d="M16 .396C7.164.396 0 7.56 0 16.396c0 2.843.742 5.616 2.151 8.055L0 32l7.748-2.031a16.002 16.002 0 008.252 2.263h.001C24.836 32.232 32 25.068 32 16.232 32 7.56 24.836.396 16 .396zm0 29.14a13.15 13.15 0 01-6.71-1.837l-.481-.286-4.6 1.207 1.228-4.481-.313-.46a13.118 13.118 0 01-2.01-7.02c0-7.269 5.918-13.186 13.186-13.186 3.522 0 6.835 1.372 9.326 3.86a13.09 13.09 0 013.86 9.326c0 7.268-5.918 13.185-13.187 13.185l-.299.001zm7.222-9.87c-.395-.197-2.342-1.156-2.705-1.288-.363-.133-.627-.198-.891.198-.263.395-1.022 1.287-1.253 1.55-.231.264-.461.296-.856.099-.395-.198-1.668-.615-3.177-1.96-1.174-1.048-1.967-2.342-2.197-2.737-.231-.396-.025-.609.173-.806.177-.176.395-.461.593-.692.197-.231.263-.395.395-.659.132-.264.066-.494-.033-.691-.099-.198-.891-2.148-1.221-2.942-.321-.773-.648-.668-.891-.68l-.758-.014c-.264 0-.692.099-1.055.494-.363.395-1.385 1.353-1.385 3.302s1.417 3.829 1.615 4.093c.197.264 2.791 4.261 6.76 5.976.945.408 1.681.651 2.256.833.948.302 1.811.259 2.492.157.76-.114 2.342-.957 2.672-1.883.33-.926.33-1.72.231-1.883-.099-.164-.362-.264-.758-.462z"/>
          </svg>
        </div>
      </div>
    </a>
  );
};

export default WhatsAppButton;
